<div class="credit-dialog" *ngIf="isError">
  <span class="credit-dialog__title">Error...</span>
  <div class="credit-dialog__title-description">
    <span class="credit-dialog__title-description-row1">Your payment could not be processed. Please try again or contact us on <a href="mailto:support@ivolatility.com">support@ivolatility.com</a> </span>
  </div>
  <div class="credit-dialog__content">
    <div class = "credit-dialog__buttons">

      <div class = "credit-dialog__buttons-left">
        <div (click)="onCancel()"
             statistic
             statisticElementName="Click cancel in Credit Data Download modal"
             class="iv-flat-button iv-flat-button-alert button credit-dialog__cancel"
        >
          <span class = "credit-dialog__text-button">CANCEL</span>
        </div>
      </div>

      <div class = "credit-dialog__buttons-right">
        <div (click)="onProceed()"
             statistic
             statisticElementName="Click Credit try again"
             class="iv-flat-button button credit-dialog__proceed"
        >
          <span style="margin-top: 10px; display: block;">TRY AGAIN</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="credit-dialog" *ngIf="balance-minus >= 0 && !isError">
  <span class="credit-dialog__title">Before you continue...</span>

  <div class="credit-dialog__title-description">
    <span class="credit-dialog__title-description-row1">We will use your available credit to allow you</span>
    <span class="credit-dialog__title-description-row2">to download this data. Please review the following:</span>
  </div>

  <div class="credit-dialog__content">

    <div class="credit-dialog__content-row">
      <div class="credit-dialog__content-row-left"> <span class="credit-dialog__content-row-left-text"> Your available balance </span> </div>
      <div class = "credit-dialog__content-row-right"><span class = "credit-dialog__content-row-right-text"> $ {{ balance | number }} </span> </div>
    </div>

    <div class="credit-dialog__content-row">
      <div class="credit-dialog__content-row-left"> <span class="credit-dialog__content-row-left-text"> This data download </span> </div>
      <div class = "credit-dialog__content-row-right"><span class = "credit-dialog__content-row-right-text"> -$ {{ minus }} </span> </div>
    </div>

    <div class="credit-dialog__content-row">
      <div class="credit-dialog__content-row-left"> <span class="credit-dialog__content-row-left-text"> New balance after download </span> </div>
      <div class = "credit-dialog__content-row-right"><span class = "credit-dialog__content-row-right-text" style="font-weight: bold; color: #00ad80"> $ {{ balance - minus | number }} </span> </div>
    </div>

    <div class = "credit-dialog__agree">
      <label class="container">
        <input
          [(ngModel)]="checkBox"
          type="checkbox"
        >
        <span class="checkmark" [ngClass]="{'credit-dialog__check-box': isWhiteCheckbox}" ></span>
      </label>
      <span class = "credit-dialog__agree-text">I agree with IVolatility terms of service and authorize IVolatility to deduct the above amount
      from my account balance.
      </span>
    </div>
    <div class="usage">
      Data will be used for personal non pro use only.
    </div>

    <div class = "credit-dialog__buttons">

      <div class = "credit-dialog__buttons-left">
        <div (click)="onCancel()"
             statistic
             statisticElementName="Click cancel in Credit Data Download modal"
             class="iv-flat-button iv-flat-button-alert button credit-dialog__cancel"
        >
          <span class = "credit-dialog__text-button">CANCEL</span>
        </div>
      </div>

      <div class = "credit-dialog__buttons-right">
        <div [class.disabled]=" !checkBox" (click)="onProceed()"
             statistic
             statisticElementName="Click proceed in Credit Data Download modal"
          class="iv-flat-button button credit-dialog__proceed"
        >
          <span style="margin-top: 2px; display: block;">PROCEED</span>
          <span style="font-size: 8pt; display: block;">and download data</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="credit-dialog" *ngIf="balance-minus < 0 && !isError">
  <span class="credit-dialog__title">Your account balance is <span style="color: rgba(251, 104, 116, 0.9)"> ${{ balance | number }} </span> </span>

  <div class="credit-dialog__title-description">
    <span class="credit-dialog__title-description-row1">You don't have enough credit so we need to charge your credit card</span>
    <span class="credit-dialog__title-description-row2">to allow you to download this data. Please review following:</span>
  </div>

  <div class="credit-dialog__content">

    <div class="credit-dialog__content-row">
      <div class="credit-dialog__content-row-left"> <span class="credit-dialog__content-row-left-text"> Your available balance </span> </div>
      <div class = "credit-dialog__content-row-right"><span class = "credit-dialog__content-row-right-text" style="font-weight: bold; color: rgba(251, 104, 116, 0.9)"> $ {{ balance | number }} </span> </div>
    </div>

    <div class="credit-dialog__content-row">
      <div class="credit-dialog__content-row-left"> <span class="credit-dialog__content-row-left-text"> This data download </span> </div>
      <div class = "credit-dialog__content-row-right"><span class = "credit-dialog__content-row-right-text"> -$ {{ minus }} </span> </div>
    </div>

    <div class="credit-dialog__content-row">
      <div class="credit-dialog__content-row-left"> <span class="credit-dialog__content-row-left-text"> Amount due </span> </div>
      <div class = "credit-dialog__content-row-right"><span class = "credit-dialog__content-row-right-text" style="font-weight: bold"> $ {{ minus - balance | number }} </span> </div>
    </div>

    <div class = "credit-dialog__agree">
      <label class="container">
        <input
          [(ngModel)]="checkBox"
          type="checkbox"
        >
        <span class="checkmark" [ngClass]="{'credit-dialog__check-box': isWhiteCheckbox}"  ></span>
      </label>
      <span class = "credit-dialog__agree-text">I agree with IVolatility terms of service and authorize IVolatility to charge ${{ minus - balance | number }}
      on the credit card registered on ivolatility.com
      </span>
    </div>

    <div class = "credit-dialog__buttons">

      <div class = "credit-dialog__buttons-left">
        <div (click)="onCancel()"
             statistic
             statisticElementName="Click cancel in Credit Data Download modal"
             class="iv-flat-button iv-flat-button-alert button credit-dialog__cancel"
        >
          <span class = "credit-dialog__text-button">CANCEL</span>
        </div>
      </div>

      <div class = "credit-dialog__buttons-right">
        <div [class.disabled]=" !checkBox" (click)="onProceed()"
             statistic
             statisticElementName="Click credit proceed"
             class="iv-flat-button button credit-dialog__proceed"
        >
          <span style="margin-top: 2px; display: block;">PROCEED</span>
          <span style="font-size: 8pt; display: block;">and download data</span>
        </div>
      </div>

    </div>
  </div>
</div>
